/**
 * Varyasyon fiyatlarını formatlayan JavaScript
 * Adet, birim fiyat ve toplam fiyat formatında gösterir
 */
class VariantPriceFormatter {
  constructor() {
    this.init();
  }

  init() {
    // Sayfa yüklendiğinde çalıştır
    document.addEventListener('DOMContentLoaded', () => {
      this.formatVariantOptions();
    });

    // Varyasyon seçenekleri değiştiğinde de çalıştır
    document.addEventListener('variant:change', () => {
      this.formatVariantOptions();
    });
  }

  formatVariantOptions() {
    // Tüm select ve radio varyasyon seçeneklerini bul
    const selects = document.querySelectorAll('select.product-variant__container--select');
    const radios = document.querySelectorAll('.product-variant__label');
    
    // Select elementlerini formatla
    selects.forEach(select => {
      this.formatSelectOptions(select);
    });
    
    // Radio butonları formatla
    radios.forEach(label => {
      this.formatRadioLabel(label);
    });
  }

  formatSelectOptions(select) {
    // Ürün varyasyonlarını al
    const variantsJson = document.querySelector('product-variants').dataset.variants;
    if (!variantsJson) return;
    
    const variants = JSON.parse(variantsJson);
    const options = select.querySelectorAll('option');
    
    options.forEach(option => {
      const value = option.value;
      if (!value || value === 'default') return;
      
      // İlk kelimeyi adet olarak al (örn. "10 Stück")
      const quantityMatch = value.match(/^(\d+)/);
      if (!quantityMatch) return;
      
      const quantity = parseInt(quantityMatch[1], 10);
      if (isNaN(quantity) || quantity <= 0) return;
      
      // Bu varyasyon değerine sahip varyantı bul
      const variant = this.findVariantByOptionValue(variants, value);
      if (!variant) return;
      
      // Birim fiyatı hesapla
      const totalPrice = variant.price / 100; // Shopify fiyatları cent olarak saklar
      const unitPrice = totalPrice / quantity;
      
      // Fiyatları formatla
      const formattedUnitPrice = this.formatPrice(unitPrice);
      const formattedTotalPrice = this.formatPrice(totalPrice);
      
      // Yeni metni oluştur
      option.textContent = `${quantity} Stück (à ${formattedUnitPrice}) ${formattedTotalPrice}`;
    });
  }

  formatRadioLabel(label) {
    // Radio butonun değerini al
    const radio = label.closest('.product-variant__item').querySelector('input[type="radio"]');
    if (!radio) return;
    
    const value = radio.value;
    if (!value) return;
    
    // İlk kelimeyi adet olarak al (örn. "10 Stück")
    const quantityMatch = value.match(/^(\d+)/);
    if (!quantityMatch) return;
    
    const quantity = parseInt(quantityMatch[1], 10);
    if (isNaN(quantity) || quantity <= 0) return;
    
    // Ürün varyasyonlarını al
    const variantsJson = document.querySelector('product-variants').dataset.variants;
    if (!variantsJson) return;
    
    const variants = JSON.parse(variantsJson);
    
    // Bu varyasyon değerine sahip varyantı bul
    const variant = this.findVariantByOptionValue(variants, value);
    if (!variant) return;
    
    // Birim fiyatı hesapla
    const totalPrice = variant.price / 100; // Shopify fiyatları cent olarak saklar
    const unitPrice = totalPrice / quantity;
    
    // Fiyatları formatla
    const formattedUnitPrice = this.formatPrice(unitPrice);
    const formattedTotalPrice = this.formatPrice(totalPrice);
    
    // Eğer label'da görünür metin varsa değiştir
    const visibleText = label.querySelector(':not(.visually-hidden)');
    if (visibleText) {
      visibleText.textContent = `${quantity} Stück (à ${formattedUnitPrice}) ${formattedTotalPrice}`;
    } else {
      // Görünür metin yoksa, label'ın içeriğini değiştir
      // Önce visually-hidden elementini koru
      const hiddenElement = label.querySelector('.visually-hidden');
      const hiddenText = hiddenElement ? hiddenElement.outerHTML : '';
      
      label.innerHTML = `${hiddenText}${quantity} Stück (à ${formattedUnitPrice}) ${formattedTotalPrice}`;
    }
  }

  findVariantByOptionValue(variants, optionValue) {
    // Varyasyon değerine göre varyantı bul
    return variants.find(variant => {
      return variant.options.some(option => option === optionValue);
    });
  }

  formatPrice(price) {
    // Fiyatı formatla (€ sembolü ile)
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(price);
  }
}

// Sınıfı başlat
new VariantPriceFormatter();
